import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

function Dashboard() {
  const [seferler, setSeferler] = useState([]);
  const [istatistik, setIstatistik] = useState({
    aktifSefer: 0,
    yolda: 0,
    gumrukte: 0,
    depodakiMal: 0,
    depodakiMusteriSayisi: 0,
    bekleyenOdeme: null,
  });
  const [yukleniyor, setYukleniyor] = useState(true);
  const [seferModal, setSeferModal] = useState(false);
  const [yeniSefer, setYeniSefer] = useState({ sefer_no: '', guzergah: 'TR → KKTC', surucu_ad: '', plaka: '', durum: 'Yükleme Bekliyor', tahmini_varis: '' });
  const [kayitYapiliyor, setKayitYapiliyor] = useState(false);

  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');

  useEffect(() => {
    veriCek();
  }, []);

  const veriCek = async () => {
    setYukleniyor(true);

    // Aktif seferler
    const { data: seferData } = await supabase
      .from('seferler')
      .select('*, sefer_musteriler(count)')
      .neq('durum', 'Teslim Edildi')
      .order('created_at', { ascending: false });

    if (seferData) {
      setSeferler(seferData);

      const yolda = seferData.filter(s => s.durum === 'Yolda').length;
      const gumrukte = seferData.filter(s => s.durum === 'Gümrükte').length;

      setIstatistik(prev => ({
        ...prev,
        aktifSefer: seferData.length,
        yolda,
        gumrukte,
      }));
    }

    // Depodaki mal
    const { data: depoData } = await supabase
      .from('depo')
      .select('musteri_id')
      .neq('durum', 'Teslim Edildi');

    if (depoData) {
      const tekMusteriler = new Set(depoData.map(d => d.musteri_id)).size;
      setIstatistik(prev => ({
        ...prev,
        depodakiMal: depoData.length,
        depodakiMusteriSayisi: tekMusteriler,
      }));
    }

    // Bekleyen ödemeler toplamı
    const { data: odemeData } = await supabase
      .from('odemeler')
      .select('toplam_tutar, odenen_tutar')
      .in('odeme_durumu', ['Bekliyor', 'Kısmi Ödendi', 'Gecikmiş']);

    if (odemeData) {
      const toplam = odemeData.reduce((t, o) => t + (o.toplam_tutar - (o.odenen_tutar || 0)), 0);
      setIstatistik(prev => ({ ...prev, bekleyenOdeme: toplam }));
    }

    setYukleniyor(false);
  };

  const modalAc = async () => {
    const yil = new Date().getFullYear();
    const prefix = `TIR-${yil}-`;
    const { data } = await supabase.from('seferler').select('sefer_no').like('sefer_no', `${prefix}%`);
    let maxNo = 0;
    (data || []).forEach(s => {
      const parca = s.sefer_no.split('-');
      const no = parseInt(parca[parca.length - 1]);
      if (!isNaN(no) && no > maxNo) maxNo = no;
    });
    const seferNo = `${prefix}${String(maxNo + 1).padStart(2, '0')}`;
    setYeniSefer({ sefer_no: seferNo, guzergah: 'TR → KKTC', surucu_ad: '', plaka: '', durum: 'Yükleme Bekliyor', tahmini_varis: '' });
    setSeferModal(true);
  };

  const seferEkle = async () => {
    if (!yeniSefer.surucu_ad) return alert('Sürücü adı zorunlu!');
    setKayitYapiliyor(true);
    const { error } = await supabase.from('seferler').insert([yeniSefer]);
    setKayitYapiliyor(false);
    if (error) { alert('Hata: ' + error.message); return; }
    setSeferModal(false);
    veriCek();
  };

  const durumRenk = (durum) => {
    switch (durum) {
      case 'Gümrükte': return { renk: '#854F0B', bg: '#FEF3C7' };
      case 'Yolda': return { renk: '#185FA5', bg: '#E6F1FB' };
      case 'Yükleme Bekliyor': return { renk: '#555', bg: '#f1f1f1' };
      case 'Teslim Edildi': return { renk: '#3B6D11', bg: '#F0FDF4' };
      case 'Dağıtımda': return { renk: '#6B21A8', bg: '#F3E8FF' };
      default: return { renk: '#555', bg: '#f1f1f1' };
    }
  };

  const tarihFormat = (tarih) => {
    if (!tarih) return '—';
    return new Date(tarih).toLocaleDateString('tr-TR');
  };

  return (
    <div style={{ flex: 1, background: '#f5f5f5', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#fff', padding: '14px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Gösterge Paneli</div>
        <div style={{ background: '#0D3B7A', color: '#fff', padding: '6px 16px', borderRadius: '20px', fontSize: '12px' }}>
          {kullanici.ad || 'Kullanıcı'}
        </div>
      </div>

      <div style={{ padding: '24px' }}>
        {/* İstatistik Kartları */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
          <div style={{ background: '#fff', borderRadius: '10px', padding: '18px', border: '1px solid #eee' }}>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>Aktif Sefer</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a' }}>
              {yukleniyor ? '...' : istatistik.aktifSefer}
            </div>
            <div style={{ fontSize: '11px', color: '#185FA5', marginTop: '4px' }}>
              {istatistik.yolda} yolda · {istatistik.gumrukte} gümrükte
            </div>
          </div>

          <div style={{ background: '#fff', borderRadius: '10px', padding: '18px', border: '1px solid #eee' }}>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>Bu Ay Teslim</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a' }}>—</div>
            <div style={{ fontSize: '11px', color: '#3B6D11', marginTop: '4px' }}>Yakında aktif</div>
          </div>

          <div style={{ background: '#fff', borderRadius: '10px', padding: '18px', border: '1px solid #eee' }}>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>Bekleyen Ödeme</div>
            <div style={{ fontSize: '22px', fontWeight: '700', color: istatistik.bekleyenOdeme > 0 ? '#DC2626' : '#1a1a1a' }}>
              {yukleniyor ? '...' : istatistik.bekleyenOdeme === null ? '—' :
                new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2 }).format(istatistik.bekleyenOdeme) + ' ₺'}
            </div>
            <div style={{ fontSize: '11px', color: '#854F0B', marginTop: '4px' }}>Bekliyor + gecikmiş</div>
          </div>

          <div style={{ background: '#fff', borderRadius: '10px', padding: '18px', border: '1px solid #eee' }}>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>Depodaki Mal</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a' }}>
              {yukleniyor ? '...' : istatistik.depodakiMal}
            </div>
            <div style={{ fontSize: '11px', color: '#555', marginTop: '4px' }}>
              kalem · {istatistik.depodakiMusteriSayisi} müşteri
            </div>
          </div>
        </div>

        {/* Aktif Seferler Tablosu */}
        <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #eee', overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '14px', fontWeight: '600' }}>Aktif Seferler</div>
            <button onClick={modalAc} style={{ background: '#0D3B7A', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' }}>
              + Yeni Sefer
            </button>
          </div>

          {yukleniyor ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Yükleniyor...</div>
          ) : seferler.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Aktif sefer bulunamadı.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f9f9f9' }}>
                  {['Sefer No', 'Güzergah', 'Sürücü / Plaka', 'Durum', 'Tahmini Varış'].map((h, i) => (
                    <th key={i} style={{ padding: '10px 20px', textAlign: 'left', color: '#888', fontWeight: '500' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {seferler.map((row, i) => {
                  const { renk, bg } = durumRenk(row.durum);
                  return (
                    <tr key={i} style={{ borderTop: '1px solid #eee' }}>
                      <td style={{ padding: '12px 20px', fontWeight: '600', color: '#0D3B7A' }}>{row.sefer_no}</td>
                      <td style={{ padding: '12px 20px' }}>{row.guzergah}</td>
                      <td style={{ padding: '12px 20px' }}>
                        <div style={{ fontWeight: '500', color: '#333' }}>{row.surucu_ad || '—'}</div>
                        <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>{row.plaka || ''}</div>
                      </td>
                      <td style={{ padding: '12px 20px' }}>
                        <span style={{ background: bg, color: renk, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>
                          {row.durum}
                        </span>
                      </td>
                      <td style={{ padding: '12px 20px', color: '#888' }}>{tarihFormat(row.tahmini_varis)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {seferModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '520px', fontFamily: 'Arial, sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#0D3B7A' }}>Yeni Sefer Ekle</div>
              <button onClick={() => setSeferModal(false)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Sefer No</div>
                <div style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', background: '#f5f7fa', color: '#0D3B7A', fontWeight: '700' }}>
                  {yeniSefer.sefer_no}
                </div>
              </div>
              {[
                { label: 'Sürücü Adı *', key: 'surucu_ad', placeholder: 'Ahmet Kara' },
                { label: 'Plaka', key: 'plaka', placeholder: '33 ABC 001' },
              ].map(f => (
                <div key={f.key}>
                  <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>{f.label}</div>
                  <input value={yeniSefer[f.key]} onChange={e => setYeniSefer({ ...yeniSefer, [f.key]: e.target.value })}
                    placeholder={f.placeholder}
                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
                </div>
              ))}
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Güzergah</div>
                <select value={yeniSefer.guzergah} onChange={e => setYeniSefer({ ...yeniSefer, guzergah: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>TR → KKTC</option>
                  <option>TR → Montenegro</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Durum</div>
                <select value={yeniSefer.durum} onChange={e => setYeniSefer({ ...yeniSefer, durum: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>Yükleme Bekliyor</option>
                  <option>Yüklendi</option>
                  <option>Yolda</option>
                  <option>Gümrükte</option>
                  <option>Dağıtımda</option>
                  <option>Teslim Edildi</option>
                </select>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Tahmini Varış</div>
                <input type="date" value={yeniSefer.tahmini_varis} onChange={e => setYeniSefer({ ...yeniSefer, tahmini_varis: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setSeferModal(false)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>İptal</button>
              <button onClick={seferEkle} disabled={kayitYapiliyor}
                style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', opacity: kayitYapiliyor ? 0.7 : 1 }}>
                {kayitYapiliyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;